export default "https://cdn-static.gokick.com/assets/62cc856e78696df0fd8dcc0a94c6851d482ca838/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";